<template>
    <div class="row" id="shops-grid">
        <div 
            class="col-md-6 col-12"
            :class="{'col-lg-4': size === 'medium', 'col-xl-4': size === 'small'}"
            v-for="(shopData, index) in list" :key="`card-${index}`"
            style="margin-bottom: 32px">
                <Shop :shop="shopData" :card-location="location"/>   
        </div>
    </div>
</template>

<script>

import Shop from './Shop'
import {useRouter} from '../../../core/hooks'
export default {
    name: 'ShopsList',
    components: {
        Shop
    },
    props: {
        list: Array,
        location: String,
        size: {
            type: String,
            default: 'small'
        }
    }
    
}
</script>